import { API } from '@/api/config'
import { ObjectToQueryString } from '@/_helper';

export default new class Infringement {
  getInfringementByBusinessId(businessId, query = { skip:0, limit:10, filter:{} }){
    let filter = '';
    if(typeof query.filter === 'object') try{ filter = JSON.stringify(query.filter) }catch(e) { throw 'Invalid Filter object'}
    query.filter = filter;
    if(query) query = '?'+ObjectToQueryString(query);
    return API.ACCOUNTS.get(`/infringement/find-by-businessId/${businessId}${query}`)
  }

  getInfringementById( query ){
      return API.ACCOUNTS.get(`/infringement/${query}`);
  }


  getInfringementByDateRange( payload ){
    return API.ACCOUNTS.post('/infringement/date-range', payload);
  }

  getSummaryReport( payload ){
    return API.ACCOUNTS.post(`/infringement/summary-report`, payload);
  }

  getDetailedReport( payload ){
    return API.ACCOUNTS.post(`/infringement/detailed-report`, payload);
  }

}